import { FC, SVGAttributes } from "react";

const PriceIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0H32V32H0z"
        transform="translate(-16 -510) translate(16 510)"
      />
      <g transform="translate(-16 -510) translate(16 510) translate(4 6)">
        <path stroke="#000" strokeWidth="2" d="M1 5H23V19H1z" />
        <circle cx="12" cy="12" r="4" stroke="#000" strokeWidth="2" />
        <path fill="#000" d="M2 2H22V3H2zM4 0H20V1H4z" />
      </g>
    </g>
  </svg>
);

export { PriceIcon };
